import Activity from "./Activity";
import ActivityFormInfoConfirm from "./ActivityFormInfoConfirm";
import ActivityInfoConfirm from "./ActivityInfoConfirm";
import ActivityNewsItem from "./ActivityNewsItem";
import BookingDetailInfo from "./BookingDetailInfo";
import BookingInfoConfirm from "./BookingInfoConfirm";
import ConditionCard from "./ConditionCard";
import CorperateInfo from "./CorperateInfo";
import CustomerActFRegisItem from "./CustomerActFRegisItem";
import MenuItem from "./MenuItem";
import MusicHallItem from "./MusicHallItem";
import MusicPracticeRoom from "./MusicPracticeRoom";
import BookingSkechedule from "./BookingSkechedule";
import MyInstrument from "./MyInstument";
import MyRewardCard from "./MyRewardCard";
import NavigationMenuItem from "./NavigationMenuItem";
import New from "./New";
import NewInfo from "./NewInfo";
import PasswordChangeSuccessfull from "./PasswordChangeSuccessfull";
import Privilege from "./Privilege";
import ProductRedeem from "./ProductRedeem";
import ProductWarrantee from "./ProductWarrantee";
import PromotionPackage from "./PromotionPackage";
import Reward from "./Reward";
import ScanInfo from "./ScanInfo";
import UpcomingEvent from "./UpcomingEvent";
import UserInfo from "./UserInfo";
import Question from "./Question";
import QuestionAnsItem from "./QuestionAnsItem";
import ProductInstrument from "./ProductInstrument";
import MyInstumentTuneBooking from "./MyInstumentTuneBooking";
import InstumentTune from "./InstumentTune";
import SeatBookingItem from "./SeatBookingItem";
import SeatTicketInfoConfirm from "./SeatTicketInfoConfirm";

const EXPORT = {
  Activity,
  ActivityFormInfoConfirm,
  ActivityInfoConfirm,
  ActivityNewsItem,
  BookingDetailInfo,
  BookingInfoConfirm,
  ConditionCard,
  CorperateInfo,
  CustomerActFRegisItem,
  InstumentTune,
  MenuItem,
  MusicHallItem,
  MusicPracticeRoom,
  BookingSkechedule,
  MyInstrument,
  MyInstumentTuneBooking,
  MyRewardCard,
  NavigationMenuItem,
  New,
  NewInfo,
  PasswordChangeSuccessfull,
  Privilege,
  ProductInstrument,
  ProductRedeem,
  ProductWarrantee,
  PromotionPackage,
  Reward,
  ScanInfo,
  UpcomingEvent,
  UserInfo,
  Question,
  QuestionAnsItem,
  SeatBookingItem,
  SeatTicketInfoConfirm,
};

export default EXPORT;
